import React from "react";

interface AddOnProps {
  addOn: {
    id: string;
    name: string;
    price: number;
    stock: number;
    sku: string;
  };
}

const AddOnCard: React.FC<AddOnProps> = ({ addOn }) => {
  return (
    <div className="border rounded-lg shadow-sm p-4 bg-white">
      <h2 className="text-lg font-semibold mb-1">{addOn.name}</h2>
      <p className="text-sm text-gray-600 mb-2">SKU: {addOn.sku}</p>
      <p className="text-sm mb-1">Price: ₹{addOn.price}</p>
      <p className="text-sm mb-1">Stock: {addOn.stock}</p>
    </div>
  );
};

export default AddOnCard;
